import type { LogoType } from '../../types';

export const featuredInMedia: LogoType[] = [
  {
    id: '55799fce',
    file: {
      data: {
        name: 'Publishing8.png',
        size: 90923,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/8932a332-2298-4ba1-9798-cfd1169f10a3.png',
        extension: 'png',
        width: 815,
        height: 445,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'ac792523',
    file: {
      data: {
        name: 'Publishing3.png',
        size: 55418,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/19d3f79d-255d-4d72-9eab-a33f98a5fb96.png',
        extension: 'png',
        width: 488,
        height: 262,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'fc771457',
    file: {
      data: {
        name: 'Publishing9.png',
        size: 63203,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/c045eb05-19c1-4969-8225-8f5b9a1b48d3.png',
        extension: 'png',
        width: 1016,
        height: 254,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '1c518cbd',
    file: {
      data: {
        name: 'Publishing7.png',
        size: 28543,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/ef9fd792-60de-4a3e-bb24-dba803651a18.png',
        extension: 'png',
        width: 807,
        height: 174,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '0589bc42',
    file: {
      data: {
        name: 'Publishing2.png',
        size: 22408,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/586311f8-6798-4b9f-ae8b-33cf849f146d.png',
        extension: 'png',
        width: 659,
        height: 107,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'f6cdb87a',
    file: {
      data: {
        name: 'Publishing4.png',
        size: 22029,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/4c08aab6-1d4a-48b9-b84d-764c6f17e2b7.png',
        extension: 'png',
        width: 647,
        height: 160,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '8c8d8edd',
    file: {
      data: {
        name: 'Publishing1.png',
        size: 25067,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/13076f34-181a-4dae-bd72-76368d1d7867.png',
        extension: 'png',
        width: 649,
        height: 227,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '886512e7',
    file: {
      data: {
        name: 'Publishing5.png',
        size: 56867,
        type: 'image/png',
        url: 'https://files.elfsight.com/storage/f7e9a9de-578a-404d-9755-29717c16030a/2e6ef9dc-beae-44b2-8435-2766a2ee6e60.png',
        extension: 'png',
        width: 1062,
        height: 192,
        alt: ''
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
